import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree
} from "vuex";
import { Notification } from "../../../../domain/entities/notifications/notification";
import notificationUseCases from "../../../../domain/usecase/impl/notification/notificationUseCases";
import { watch } from "vue";
import { AlertBoxState } from "./alert_box_module";
class NotificationState {
  notifications: Notification[] = [];
  hasNewNotifications = false;
}

const state = new NotificationState();

const mutations: MutationTree<NotificationState> = {
  SET_NOTIFICATIONS(
    state: NotificationState,
    notifications: Notification[]
  ): void {
    state.notifications = notifications;
    if (state.notifications) {
      const newNotifications = state.notifications.find(
        (notification: Notification) => !notification.isRead
      );
      state.hasNewNotifications = !!newNotifications;
    }
  },

  SET_NEW_NOTIFICATIONS_INDICATOR(
    state: NotificationState,
    hasNewNotifications: boolean
  ): void {
    state.hasNewNotifications = hasNewNotifications;
  }
};

const actions: ActionTree<NotificationState, NotificationState> = {
  async list({
    commit
  }: ActionContext<NotificationState, NotificationState>): Promise<void> {
    try {
      const response: Notification[] = await notificationUseCases.list();
      commit("SET_NOTIFICATIONS", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async watch(
    { commit }: ActionContext<NotificationState, NotificationState>,
    notificationID: number
  ): Promise<void> {
    try {
      return await notificationUseCases.watch(notificationID);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async delete(
    { commit }: ActionContext<NotificationState, NotificationState>,
    notificationID: number
  ): Promise<void> {
    try {
      return await notificationUseCases.delete(notificationID);
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
};

const getters: GetterTree<NotificationState, NotificationState> = {
  notifications: (state: NotificationState): Notification[] =>
    state.notifications,
  hasNewNotifications: (state: NotificationState): boolean =>
    state.hasNewNotifications
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<NotificationState, NotificationState>;
